import React, {
  Dispatch,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { ItemTypes, PopupsListType } from "./RightSideMenu";
import closeIco from "../../assets/close-icon-color.png";
import fullScreenIco from "../../assets/full-screen-ico.png";
import { Coordinate } from "ol/coordinate";
import EWSRiverChart from "../../mainLayer/earlyWarning/EWSRiverChart";
import TypingDots from "../../animations/TypingDots";
import {
  EWSSidebarMap,
  openEwsWindowsMap,
} from "../../mainLayer/earlyWarning/ShowEarlyWarning";
import { useEWSContext } from "../../provider/EWSProvider";
import ReactDOM from "react-dom";
import { map } from "../../mainLayer/MainLayer";
import Overlay from "ol/Overlay";
import EarlyWarningPopup from "../../mainLayer/earlyWarning/EarlyWarningPopup";

// import EWSRiverChart from '../EarlyWarningComp/EWSRiverChart';

type EarlyWarningInfoType = {
  code: string;
  name: string;
  color: string;
  icon: string;
  iconGif: string;
};

type SideMenuPopupsType = {
  warningId: string;
  coordinates: Coordinate | null;
  adm4_en: string | null;
  active_pcode: string | null;
  end_time: string | null;
  s_desc: string | null;
  severity_index: string | null;
  severity: string | null;
  adm4_pcode: string | null;
  adm3_pcode: string | null;
  adm3_en: string | null;
  adm2_pcode: string | null;
  adm2_en: string | null;
  active_alevel: string | null;
  en_desc: string | null;
  validityPeriod: string | null;
  issued_time: string | null;
  w_status: string | null;
  w_desc: string | null;
  w_name: string | null;
  w_type: string | null;
  adm1_en: string | null;
  widthValue: number;
  setEWSRender: () => void;
  setPopups: Dispatch<React.SetStateAction<PopupsListType[]>>;
  onActivePcode: (activePcode: string | null) => void;
  removeItem: (id: string, type: ItemTypes) => void;
  addItem: (id: string, type: ItemTypes) => void;
};

const SideMenuEarlyWarningPopup = (props: SideMenuPopupsType) => {
  // Selected tab
  const [selectedTab, setSelectedTab] = useState<
    "early_warning_data_tab" | "realtime_data_tab" | "forecast_tab"
  >("early_warning_data_tab");
  // Forecast selected model
  const [selectedForecastModel, setSelectedForecastModel] = useState<
    "forecast_model_ecmwf" | "forecast_model_gfs" | "forecast_model_icon"
  >("forecast_model_ecmwf");

  // Nearest river gauges status
  const [isNearestRiverGaugeOpen, setIsNearestRiverGaugeOpen] =
    useState<boolean>(true);
  // Nearest rainfall gauges status
  const [isNearestRainfallGaugeOpen, setIsNearestRainfallGaugeOpen] =
    useState<boolean>(false);
  // Nearest early warning status
  const [isNearestReportedIncidentOpen, setIsNearestReportedIncidentOpen] =
    useState<boolean>(false);
  const { EWSOpenSidebarMap, removeFromEWSOpenSidebarMap } = useEWSContext();
  const [warningType, setWarningType] = useState<
    EarlyWarningInfoType | undefined
  >();
  const warningImgRef = useRef<string>("");

  // Handle close
  const handleClosePopupClick = (name: string) => {
    props.setPopups((prevState) =>
      prevState.filter((obj) => obj.name !== name)
    );
  };

  const [widthMain, setWidthMain] = useState<number>(0);
  const [heightMain, setHeightMain] = useState<number>(0);

  useEffect(() => {
    setWidthMain(props.widthValue);
  }, [props.widthValue, widthMain, heightMain]);

  const colorContainer = new Map([
    ["3", "red"],
    ["1", "rgb(235, 235, 2)"],
    ["2", "rgb(255, 185, 54)"],
  ]);

  useEffect(() => {
    const entries = Array.from(EWSOpenSidebarMap.values());
    const lastEntryIndex = entries.length - 1;
    entries.forEach((details, index) => {
      const { coordinates, active_pcode } = details;
      if (coordinates) {
        removeOverlay(active_pcode!);
        if (index === lastEntryIndex) {
          // Handle last entry
          addOverlayClickItemLast(active_pcode!, coordinates);
        } else {
          // Handle all other entries
          addOverlayClickItem(active_pcode!, coordinates);
        }
      }
    });
  }, [EWSOpenSidebarMap.size]);

  const removeEWSById = (id: string) => {
    removeFromEWSOpenSidebarMap(id);
    openEwsWindowsMap.set(id, "close");
    props.setEWSRender();
    removeOverlay(id);
    if (EWSSidebarMap.has(id)) {
      EWSSidebarMap.delete(id);
    }
  };

  const removeOverlay = (key: string) => {
    const overlays = map.getOverlays().getArray();
    const overlaysToRemove = overlays.filter(
      (overlay) => overlay.getId() === key
    );
    overlaysToRemove.forEach((overlay) => {
      map.removeOverlay(overlay);
    });
  };

  const addOverlayClickItem = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "location-dot animate";

    const ringElement = document.createElement("div");
    ringElement.className = "location-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  const addOverlayClickItemLast = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "locationlast-dot animate";

    const ringElement = document.createElement("div");
    ringElement.className = "locationlast-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  const [isNotRelease, setIsNotRelease] = useState<boolean>(true);

  const popupRef = useRef<HTMLDivElement | null>(null);
  const popupElement = document.createElement("earlyWarningElement");

  const mouseMoveEvent = useCallback(
    (event: MouseEvent) => {
      const sideMenu = document.getElementById("side-menu-wrapper");

      if (sideMenu && isNotRelease) {
        const sideMenuWidth = Number(
          window.getComputedStyle(sideMenu).left.slice(0, -2)
        );

        if (sideMenuWidth > event.clientX) {
          ReactDOM.render(
            <EarlyWarningPopup
              warningId={props.warningId!}
              coordinates={props.coordinates}
              adm4_en={props.adm4_en}
              active_pcode={props.active_pcode}
              end_time={props.end_time}
              s_desc={props.s_desc}
              severity_index={props.severity_index}
              severity={props.severity}
              adm4_pcode={props.adm4_pcode}
              adm3_pcode={props.adm3_pcode}
              adm3_en={props.adm3_en}
              adm2_pcode={props.adm2_pcode}
              adm2_en={props.adm2_en}
              active_alevel={props.active_alevel}
              en_desc={props.en_desc}
              validityPeriod={props.validityPeriod}
              issued_time={props.issued_time}
              w_status={props.w_status}
              w_desc={props.w_desc}
              w_name={props.w_name}
              w_type={props.w_type}
              onClose={handleClose}
              adm1_en={props.adm1_en}
              addItem={props.addItem}
              id={props.active_pcode!}
            />,
            popupElement
          );

          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });

          overlay.setPosition(props.coordinates!);
          map.addOverlay(overlay);
          props.onActivePcode(props.active_pcode!);
          props.removeItem(props.active_pcode!, "ew");
          setIsNotRelease(false);
        }
      }
    },
    [isNotRelease]
  );

  const mouseMoveEventTouch = useCallback(
    (event: TouchEvent) => {
      const sideMenu = document.getElementById("side-menu-wrapper");

      if (sideMenu && isNotRelease) {
        const sideMenuWidth = Number(
          window.getComputedStyle(sideMenu).left.slice(0, -2)
        );
        const touchX = event.touches[0].clientX; // Get touch position
  
        if (sideMenuWidth > touchX) {
          ReactDOM.render(
            <EarlyWarningPopup
              warningId={props.warningId!}
              coordinates={props.coordinates}
              adm4_en={props.adm4_en}
              active_pcode={props.active_pcode}
              end_time={props.end_time}
              s_desc={props.s_desc}
              severity_index={props.severity_index}
              severity={props.severity}
              adm4_pcode={props.adm4_pcode}
              adm3_pcode={props.adm3_pcode}
              adm3_en={props.adm3_en}
              adm2_pcode={props.adm2_pcode}
              adm2_en={props.adm2_en}
              active_alevel={props.active_alevel}
              en_desc={props.en_desc}
              validityPeriod={props.validityPeriod}
              issued_time={props.issued_time}
              w_status={props.w_status}
              w_desc={props.w_desc}
              w_name={props.w_name}
              w_type={props.w_type}
              onClose={handleClose}
              adm1_en={props.adm1_en}
              addItem={props.addItem}
              id={props.active_pcode!}
            />,
            popupElement
          );

          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });

          overlay.setPosition(props.coordinates!);
          map.addOverlay(overlay);
          props.onActivePcode(props.active_pcode!);
          props.removeItem(props.active_pcode!, "ew");
          setIsNotRelease(false);
        }
      }
    },
    [isNotRelease]
  );

    useEffect(() => {
      const handleMouseDown = () => {
        document.addEventListener("mousemove", mouseMoveEvent);
        document.addEventListener("mouseup", handleMouseUp);
      };
    
      const handleMouseUp = () => {
        document.removeEventListener("mousemove", mouseMoveEvent);
        document.removeEventListener("mouseup", handleMouseUp);
      };
    
      const handleTouchStart = () => {
        document.addEventListener("touchmove", mouseMoveEventTouch);
        document.addEventListener("touchend", handleTouchEnd);
      };
    
      const handleTouchEnd = () => {
        document.removeEventListener("touchmove", mouseMoveEventTouch);
        document.removeEventListener("touchend", handleTouchEnd);
      };
    
      if (popupRef.current) {
        popupRef.current.addEventListener("mouseenter", () => {
          popupRef.current?.addEventListener("mousedown", handleMouseDown);
          popupRef.current?.addEventListener("touchstart", handleTouchStart);
        });
      }
    
      return () => {
        document.removeEventListener("mousemove", mouseMoveEvent);
        document.removeEventListener("mouseup", handleMouseUp);
        document.removeEventListener("touchmove", mouseMoveEventTouch);
        document.removeEventListener("touchend", handleTouchEnd);
      };
    }, [mouseMoveEvent, mouseMoveEventTouch]);

  const handleClose = (incidentId: string) => {
    removeFromEWSOpenSidebarMap(incidentId);

    openEwsWindowsMap.set(incidentId, "close");
    if (EWSSidebarMap.has(incidentId)) {
      EWSSidebarMap.delete(incidentId);
    }
  };

  return (
    <div className={`popup`}>
      <div className={`titleWrapper`} ref={popupRef}>
        <span>{props.w_name}</span>
        <div className={`titleButtonContainer no-drag`}>
          {/* <i className={`titleIcon fullScreenIco`}></i> */}
          <i
            className={`titleIcon closeIco`}
            onClick={(e) => {
              if (props.warningId !== null) {
                removeEWSById(props.active_pcode ?? "");
              }
            }}
            onTouchStart={(e) => {
              if (props.warningId !== null) {
                removeEWSById(props.active_pcode ?? "");
              }
            }}
          ></i>
        </div>
      </div>
      <div className={`tabArea no-drag`}>
        <div
          className={`tabButton ${
            selectedTab === "early_warning_data_tab" ? "tabSelected" : ""
          }`}
          id="early_warning_data_tab"
          onClick={(e) =>
            setSelectedTab((prevState) => "early_warning_data_tab")
          }
          onTouchStart={(e) =>
            setSelectedTab((prevState) => "early_warning_data_tab")
          }
        >
          early warnings
        </div>
        <div
          className={`tabButton ${
            selectedTab === "realtime_data_tab" ? "tabSelected" : ""
          }`}
          id="realtime_data_tab"
          onClick={(e) => setSelectedTab((prevState) => "realtime_data_tab")}
          onTouchStart={(e) => setSelectedTab((prevState) => "realtime_data_tab")}
        >
          real-time data
        </div>
        <div
          className={`tabButton ${
            selectedTab === "forecast_tab" ? "tabSelected" : ""
          }`}
          id="forecast_tab" /* onClick={(e) => setSelectedTab(prevState => 'forecast_tab')} */
        >
          forecast
        </div>
      </div>
      {selectedTab === "early_warning_data_tab" && (
        <div className={`tabEarlyWarningDataContainer`}>
          <div className={`detailsContainer`}>
            <div
              className={`iconContainer`}
              style={{
                backgroundColor: `${colorContainer.get(
                  props.severity_index || "default"
                )}`,
              }}
            >
              <span>
                {props.w_name} - {props.adm3_en}
              </span>
            </div>
            <div className={`dataRow`}>
              <span className={`name`}>Description</span>
              <span className={`data`}>
                {props.en_desc} {<TypingDots />}
              </span>
            </div>
            <div className={`dataRow`}>
              <span className={`name`}>Division</span>
              <span className={`data`}>{props.adm3_en}</span>
            </div>
            <div className={`dataRow`}>
              <span className={`name`}>District</span>
              <span className={`data`}>{props.adm2_en}</span>
            </div>
            <div className={`dataRow`}>
              <span className={`name`}>Province</span>
              <span className={`data`}>{props.adm1_en}</span>
            </div>
            <div className={`dataRow`}>
              <span className={`name`}>Severity</span>
              <span className={`data`}>{props.severity}</span>
            </div>
            <div className={`dataRow`}>
              <span className={`name`}>Start Date</span>
              <span className={`data`}>{props.issued_time}</span>
            </div>

            <div className={`dataRow`}>
              <span className={`name`}>End Date</span>
              <span className={`data`}>{props.validityPeriod}</span>
            </div>
            <div className={`dataRow`}>
              <span className={`name`}>Status</span>
              <span className={`data`}>{props.w_status}</span>
            </div>
          </div>
        </div>
      )}
      {selectedTab === "realtime_data_tab" && (
        <div className={`tabRealtimeDataContainer`}>
          {/* Nearest river gauges */}

          <div className={`mapContainer`}>
            <div
              className={`titleContainer no-drag`}
              style={{
                borderRadius: `${
                  isNearestRiverGaugeOpen ? "0.5rem 0.5rem 0 0" : "0.5rem"
                }`,
                color:"var(--text-color)"
              }}
              onClick={(e) =>
                setIsNearestRiverGaugeOpen((prevState) => !prevState)
              }
              onTouchStart={(e) =>
                setIsNearestRiverGaugeOpen((prevState) => !prevState)
              }
            >
              <span>nearest river gauges</span>
              <i className={`${isNearestRiverGaugeOpen ? "up" : "down"}`}></i>
            </div>
            {isNearestRiverGaugeOpen && (
              <div className={`mapDetailsContainer`}>
                <div
                  className="no-drag"
                  style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    alignItems: "start",
                    margin: "15px",
                    flexDirection: "column",
                    justifyContent: "top",
                  }}
                >
                  <EWSRiverChart
                    id="Nawalapitiya"
                    name="Mahaweli Ganga(Nawalapitiya)"
                    critical={2}
                    cautious={1}
                    warning={0.75}
                    fullScreen={false}
                    showDialog={false}
                    chartWidth={
                      widthMain > 1000 ? widthMain * 0.7 : widthMain * 0.8
                    }
                    chartHeight={300}
                  />
                </div>
                <div
                  className="no-drag"
                  style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    alignItems: "start",
                    margin: "15px",
                    flexDirection: "column",
                    justifyContent: "top",
                  }}
                >
                  <EWSRiverChart
                    id="Nawalapitiya"
                    name="Mahaweli Ganga(Nawalapitiya)"
                    critical={2}
                    cautious={1}
                    warning={0.75}
                    fullScreen={false}
                    showDialog={false}
                    chartWidth={
                      widthMain > 1000 ? widthMain * 0.7 : widthMain * 0.8
                    }
                    chartHeight={300}
                  />
                </div>
                <div
                  className="no-drag"
                  style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    alignItems: "start",
                    margin: "15px",
                    flexDirection: "column",
                    justifyContent: "top",
                  }}
                >
                  <EWSRiverChart
                    id="Nawalapitiya"
                    name="Mahaweli Ganga(Nawalapitiya)"
                    critical={2}
                    cautious={1}
                    warning={0.75}
                    fullScreen={false}
                    showDialog={false}
                    chartWidth={
                      widthMain > 1000 ? widthMain * 0.7 : widthMain * 0.8
                    }
                    chartHeight={300}
                  />
                </div>
              </div>
            )}
          </div>

          {/* Nearest rainfall gauges */}
          {/* {props.nearestRainfallGauges && (
                        <div className={`mapContainer`}>
                            <div className={`titleContainer`} style={{borderRadius: `${isNearestRainfallGaugeOpen ? '0.5rem 0.5rem 0 0' : '0.5rem'}`}} onClick={(e) => setIsNearestRainfallGaugeOpen(prevState => !prevState)}>
                                <span>nearest rainfall gauges</span>
                                <i className={`${isNearestRainfallGaugeOpen ? 'up' : 'down'}`}></i>
                            </div>
                            {isNearestRainfallGaugeOpen && (
                                <div className={`mapDetailsContainer`}>
                                    
                                    <div
                                className="no-drag"
                                style={{
                                height: "100%",
                                width: '100%',
                                display: "flex",
                                alignItems: "start",
                                margin: "15px",
                                flexDirection: "column",
                                justifyContent: "top"
                                }}
                            >
                                <EWSRiverChart
                                    id="Nawalapitiya"
                                    name="Mahaweli Ganga(Nawalapitiya)"
                                    critical={2}
                                    cautious={1}
                                    warning={0.75}
                                    fullScreen={false}
                                    showDialog={false}
                                    chartWidth={300}
                                    chartHeight={300}
                                />
                            </div>
                                </div>
                            )}
                        </div>
                    )} */}

          {/* Nearest reported incident */}
          {/* {props.nearestReportedIncidents && (
                        <div className={`mapContainer`}>
                            <div className={`titleContainer`} style={{borderRadius: `${isNearestReportedIncidentOpen ? '0.5rem 0.5rem 0 0' : '0.5rem'}`}} onClick={(e) => setIsNearestReportedIncidentOpen(prevState => !prevState)}>
                                <span>nearest reported incidents</span>
                                <i className={`${isNearestReportedIncidentOpen ? 'up' : 'down'}`}></i>
                            </div>
                            {isNearestReportedIncidentOpen && (
                                <div className={`mapDetailsContainer`}>
                                     Nearest reported incident map here 
                                    
                                </div>
                            )}
                        </div>
                    )} */}
        </div>
      )}
    </div>
  );
};

export default SideMenuEarlyWarningPopup;
